import { MultiSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items as originalItems } from "designSystemLegacy/data";
import { sortedByGroupItems as originalGroupedItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";
import { getNoneComponentItem } from "designSystem/utilities/component-item-functions";
import { useLocale } from "designSystem/locale";

export default () => {
	const loc = useLocale();

	const noneItem =  getNoneComponentItem(loc);
	noneItem.name = loc.resource(noneItem.name);

	const items = cloneDeep(originalItems);
	items.unshift(noneItem);
	items[1].invalid = true;
	items[2].invalid = true;

	const values = [items[1], items[2], items[3]];

	const groupedItems = cloneDeep(originalGroupedItems);
	groupedItems.unshift(noneItem);
	groupedItems[1].group = "";
	groupedItems[1].invalid = true;

	const groupedValues = [groupedItems[1], groupedItems[2], groupedItems[3]];

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="No groups" />
			<Text semiBold text="Grouped" />
			<MultiSelect
				options={items}
				value={values}
			/>
			<MultiSelect
				grouped
				options={groupedItems}
				value={groupedValues}
			/>
		</CssColumnGrid>
	);
};